import React from 'react';
import { get } from 'lodash';
import { TextField, useRecordContext } from 'react-admin';

import { Box, Grid, Typography } from '@mui/material';
import Answer from '../Answer';

import languages, { Languages } from '../../../../constants/languages';
import conflictFields from '../../../../constants/conflictFields';
import { TextQuestionParameters } from '../../questionParameters';

const CONTENT = {
  [languages.SV]: 'Gatuadress',
  [languages.EN]: 'Address',
  [languages.DE]: 'Adresse',
};

const ValueField = () => {
  const record = useRecordContext();

  const value = get(record, 'value');
  const sx = get(record, 'sx', {});

  return <TextField record={{ value }} sx={sx} source="value" emptyText="-" fontWeight="bold" />;
};

const Address = ({ extraParameters }: { extraParameters?: TextQuestionParameters }) => {
  const record = useRecordContext();

  const language = record?.language as Languages;

  return (
    <Answer
      label={extraParameters?.label ?? CONTENT[language]}
      source="address"
      datapoint={conflictFields.ADDRESS}
      identificationInfo={undefined}
    >
      <ValueField />
    </Answer>
  );
};

Address.ValueField = ValueField;

Address.Nested = ({ source, extraParameters }: {
  source?: string;
  extraParameters?: TextQuestionParameters;
}) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const record = useRecordContext();
  const sx = get(record, 'sx', {});

  const language = record?.language as Languages;

  return (
    <Grid
      size={{
        xs: 12,
        md: 3,
      }}
    >
      <Box display="flex" flexDirection="column">
        <Typography variant="label">{extraParameters?.label ?? CONTENT[language]}</Typography>
        <TextField
          source={source ?? 'address'}
          emptyText="-"
          sx={sx}
        />
      </Box>
    </Grid>
  );
};

export default Address;
